import { createIcon } from '../icon'
import MenuDrawer from '../svg/MenuDrawer'

export const MenuDrawerDefault = createIcon(MenuDrawer)
